import { render, staticRenderFns } from "./EventStats.vue?vue&type=template&id=d827f01e&"
import script from "./EventStats.vue?vue&type=script&lang=js&"
export * from "./EventStats.vue?vue&type=script&lang=js&"
import style0 from "./EventStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports